<script>
// import { formatMonto } from "@/utils";

export default {
  name: "Hyperlink",
  functional: true,
  props: {
    openSelect: {
      type: Function
    },
    row: {
      type: Object
    },
    column: {
      type: String
    },
    rowValue: {
      type: [String, Number, Object, Array, Function],
      require: false
    },
    isTotal: {
      type: Boolean,
      default: false
    }
  },

  render(createElement, context) {
    const { isTotal } = context.props;

    function displayValue(props) {
      if (!props.getType) {
        const value = props.row[props.column];

        if (value == "0.00" || value == "0") {
          return 0;
        }

        return Number(parseFloat(value).toFixed(2)).toLocaleString("en");
      }

      const value = props.row[props.column];

      if (value == "0" || value == "0.00") {
        return 0;
      }

      console.log(Number(parseFloat(value).toFixed(2)));
      return Number(parseFloat(value).toFixed(2)).toLocaleString("en");
    }

    if (isTotal) {
      return createElement("span", {}, displayValue(context.props));
    }

    return createElement(
      "a",
      {
        attrs: {
          href: "#"
        },
        on: {
          click: () => {
            context.props.openSelect(context.props);
          }
        },
        style: {
          color: ""
        }
      },
      displayValue(context.props)
    );
  }
};
</script>
